<div class="ai-pane-wrap" [class.ai-pane-expanded]="expanded">

  <div class="ai-panel-header">
    <!-- Crew / room banner: sprite + name -->
    <div class="ai-panel-crew-banner" *ngIf="targetSpriteId || targetName">
      <pss-sprite *ngIf="targetSpriteId" class="ai-panel-crew-sprite" [spriteId]="targetSpriteId"></pss-sprite>
      <span class="ai-panel-crew-name">{{ targetName }}</span>
    </div>

    <!-- Line count + Delete All + Copy / Select actions -->
    <div class="ai-pane-controls">
      <span class="ai-rule-counter">{{ sortedRules.length }} line{{ sortedRules.length !== 1 ? 's' : '' }}</span>
      <button class="ai-delete-all-btn" (click)="onDeleteAllRules()" [disabled]="saving">Delete All</button>

      <div class="ai-transfer-row ai-transfer-inline">
        <ng-container *ngIf="!lineSelectionMode">
          <button class="ai-transfer-btn" [disabled]="saving || sortedRules.length === 0" (click)="copyExport()" title="Copy Pixel Prestige AI URL to clipboard">
            {{ copied ? 'Copied!' : 'Copy AI' }}
          </button>
          <button class="ai-transfer-btn" [disabled]="saving || sortedRules.length === 0" (click)="toggleLineSelectionMode()" title="Select rules to act on">
            Select lines
          </button>
          <button class="ai-transfer-btn ai-import-toggle" [disabled]="saving" (click)="showImport = !showImport; importError = ''" title="Import AI from Pixel Prestige">
            {{ showImport ? 'Cancel' : 'Import AI' }}
          </button>
          <button class="ai-transfer-btn" [disabled]="!targetId" (click)="toggleSnapshots()" title="Save and load AI snapshots">
            {{ showSnapshots ? 'Hide Snapshots' : 'Snapshots' }}
          </button>
          <button *ngIf="userName === 'Lord Trist'" class="ai-transfer-btn ai-library-btn" (click)="toggleLibrary()" title="AI rule library — save, reuse and share across crew and rooms">
            Library
          </button>
        </ng-container>

        <ng-container *ngIf="lineSelectionMode">
          <button class="ai-transfer-btn" [disabled]="!hasSelection" (click)="copySelectedExport()">
            Copy selected{{ hasSelection ? ' (' + selectedRuleKeys.size + ')' : '' }}
          </button>
          <button class="ai-transfer-btn" [disabled]="!hasSelection" (click)="deleteSelected()">
            Delete selected{{ hasSelection ? ' (' + selectedRuleKeys.size + ')' : '' }}
          </button>
          <button class="ai-transfer-btn" [disabled]="!hasSelection" (click)="snapshotSelected()">
            Snapshot selected{{ hasSelection ? ' (' + selectedRuleKeys.size + ')' : '' }}
          </button>
          <button class="ai-transfer-btn ai-cancel-selection-btn" (click)="toggleLineSelectionMode()" title="Cancel line selection">
            Cancel
          </button>
        </ng-container>
      </div>
    </div>

    <div class="ai-confirm-overlay" *ngIf="showDeleteAllConfirm" (click)="cancelDeleteAllRules()">
      <div class="ai-confirm-box" (click)="$event.stopPropagation()">
        <div class="ai-confirm-title">Delete all AI rules?</div>
        <div class="ai-confirm-msg">Are you sure you want to delete all AI rules? This action cannot be undone.</div>
        <div class="ai-confirm-actions">
          <button class="btn btn-ghost" (click)="cancelDeleteAllRules()">Cancel</button>
          <button class="btn btn-danger" (click)="confirmDeleteAllRules()">Delete</button>
        </div>
      </div>
    </div>

    <div class="ai-confirm-overlay" *ngIf="showDeleteSelectedConfirm" (click)="cancelDeleteSelected()">
      <div class="ai-confirm-box" (click)="$event.stopPropagation()">
        <div class="ai-confirm-title">Delete selected AI rules?</div>
        <div class="ai-confirm-msg">Are you sure you want to delete {{ selectedRuleKeys.size }} selected rule(s)? This action cannot be undone.</div>
        <div class="ai-confirm-actions">
          <button class="btn btn-ghost" (click)="cancelDeleteSelected()">Cancel</button>
          <button class="btn btn-danger" (click)="confirmDeleteSelected()">Delete</button>
        </div>
      </div>
    </div>

    <div class="ai-confirm-overlay" *ngIf="showSaveSnapshotConfirm" (click)="cancelSaveSnapshotConfirm()">
      <div class="ai-confirm-box" (click)="$event.stopPropagation()">
        <div class="ai-confirm-title">Save AI snapshot?</div>
        <div class="ai-confirm-msg">Saving this snapshot saves the AI to the pss-companion database. Confirm to continue, or cancel.</div>
        <label class="ai-replace-label">
          <input type="checkbox" [(ngModel)]="dontShowSaveSnapshotWarning">
          Do not show again
        </label>
        <div class="ai-confirm-actions">
          <button class="btn btn-ghost" (click)="cancelSaveSnapshotConfirm()">Cancel</button>
          <button class="btn btn-danger" (click)="confirmSaveSnapshot()">Save</button>
        </div>
      </div>
    </div>

    <div class="ai-import-panel" *ngIf="showImport">
      <ng-container *ngIf="!pendingImport">
        <input class="ai-import-input" [(ngModel)]="importText" placeholder="Paste cmds string or Pixel Prestige URL..." autocomplete="off" maxlength="4096">
        <button class="ai-add-btn" [disabled]="saving || !importText.trim()" (click)="onImport()">Preview</button>
        <div class="crew-err ai-err" *ngIf="importError">{{ importError }}</div>
      </ng-container>

      <ng-container *ngIf="pendingImport">
        <div class="ai-import-warning" *ngIf="!appendToEnd">Warning: applying will delete all existing AI rules and replace them with the {{ pendingImport.length }} rule(s) below. This is saved immediately to the game and cannot be undone.</div>
        <div class="ai-import-preview">
          <div class="ai-import-preview-row" *ngFor="let r of pendingImport; let i = index">
            <span class="ai-rule-index">{{ (appendToEnd ? sortedRules.length : 0) + i + 1 }}.</span>
            <span class="ai-cond">{{ pendingConditionName(r.conditionTypeId) }}</span>
            <span class="ai-arrow">→</span>
            <span class="ai-act">{{ pendingActionName(r.actionTypeId) }}</span>
          </div>
        </div>
        <label class="ai-replace-label">
          <input type="checkbox" [(ngModel)]="appendToEnd"> Append to end
        </label>
        <div class="crew-err ai-err" *ngIf="appendWouldExceedLimit()">
          Cannot append: {{ internalRules.length }} existing + {{ pendingImport.length }} imported = {{ internalRules.length + pendingImport.length }} rules (max {{ 55 }}).
        </div>
        <div class="ai-import-confirm-row">
          <button class="ai-add-btn" [disabled]="saving || appendWouldExceedLimit()" (click)="onApplyClick()">Apply</button>
          <button class="ai-transfer-btn" (click)="onCancelImport()">Cancel</button>
        </div>

        <div class="ai-confirm-overlay" *ngIf="showApplyOverwriteConfirm" (click)="cancelApplyOverwrite()">
          <div class="ai-confirm-box" (click)="$event.stopPropagation()">
            <div class="ai-confirm-title">Replace all AI rules?</div>
            <div class="ai-confirm-msg">This will delete your {{ internalRules.length }} existing rule{{ internalRules.length !== 1 ? 's' : '' }} and replace them with the {{ pendingImport.length }} imported rule{{ pendingImport.length !== 1 ? 's' : '' }}. This is saved immediately to the game and cannot be undone.</div>
            <div class="ai-confirm-actions">
              <button class="btn btn-ghost" (click)="cancelApplyOverwrite()">Cancel</button>
              <button class="btn btn-danger" (click)="confirmApplyOverwrite()">Replace</button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Snapshot panel -->
    <div class="ai-snapshot-panel" *ngIf="showSnapshots && targetId">
      <div class="ai-snapshot-save-row">
        <ng-container *ngIf="showSaveSnapshot; else showSaveBtn">
        <div *ngIf="snapshotSelectedRules?.length" class="ai-selected-snapshot-preview">
          <div class="ai-snapshot-preview-title">Snapshot will include selected rules:</div>
          <div class="ai-import-preview">
            <div class="ai-import-preview-row" *ngFor="let r of snapshotSelectedRules; let i = index">
              <span class="ai-rule-index">{{ i + 1 }}.</span>
              <span class="ai-cond">{{ conditionName(r.conditionTypeId) }}</span>
              <span class="ai-arrow">→</span>
              <span class="ai-act">{{ actionLabel(r.actionTypeId) }}</span>
            </div>
          </div>
        </div>
        <input class="ai-import-input ai-snapshot-name-input"
               [(ngModel)]="newSnapshotName"
               placeholder="Snapshot name..."
               maxlength="100"
               autocomplete="off"
               (keyup.enter)="onSaveSnapshot()">
        <button class="ai-add-btn" [disabled]="savingSnapshot || !newSnapshotName.trim() || showSaveSnapshotConfirm" (click)="onSaveSnapshot()">
          {{ savingSnapshot ? '...' : 'Save' }}
        </button>
        <button class="ai-transfer-btn" (click)="showSaveSnapshot = false; newSnapshotName = ''; snapshotSelectedRules = null; snapshotAddToLibrary = false; snapshotSaveToFolderId = null">Cancel</button>
        <!-- Add to Library option -->
        <div class="ai-snapshot-library-opt">
          <label class="ai-replace-label">
            <input type="checkbox" [(ngModel)]="snapshotAddToLibrary" (change)="onSnapshotAddToLibraryChange()">
            Also add to library
          </label>
          <ng-container *ngIf="snapshotAddToLibrary">
            <div class="ai-library-folder-select-row" style="margin-top:0.3rem;">
              <select class="ai-library-folder-select" [(ngModel)]="snapshotSaveToFolderId">
                <option [ngValue]="null">— No folder —</option>
                <option *ngFor="let f of libraryFolders" [ngValue]="f.folderId">📁 {{ f.name }}</option>
              </select>
              <button class="ai-transfer-btn ai-library-new-folder-inline-btn"
                      (click)="showInlineFolderModal = true; inlineFolderName = ''; inlineFolderError = ''"
                      title="Create a new folder">+ New folder…</button>
            </div>
          </ng-container>
        </div>
        </ng-container>
        <ng-template #showSaveBtn>
          <button class="ai-transfer-btn ai-snapshot-save-btn" [disabled]="saving || sortedRules.length === 0" (click)="showSaveSnapshot = true" title="Save current rules as a new snapshot">
            + Save Snapshot
          </button>
        </ng-template>
      </div>

      <div class="crew-err ai-err" *ngIf="snapshotError">{{ snapshotError }}</div>

      <ng-container *ngIf="!snapshotsLoading; else snapshotsLoadingTpl">
        <div class="ai-snapshot-empty" *ngIf="snapshots.length === 0">No snapshots saved yet.</div>
        <div class="ai-snapshot-list" *ngIf="snapshots.length > 0">
          <div class="ai-snapshot-row" *ngFor="let snap of snapshots">
            <div class="ai-snapshot-info">
              <span class="ai-snapshot-name">{{ snap.name }}</span>
              <span class="ai-snapshot-date">{{ snap.createdAt | date:'MMM d, y, h:mm a' }}</span>
            </div>
            <div class="ai-snapshot-actions">
              <button class="ai-transfer-btn ai-snapshot-load-btn"
                      [disabled]="saving"
                      (click)="onPreviewSnapshot(snap)"
                      title="Preview this snapshot in import preview">Preview</button>
              <button class="ai-delete-btn"
                      (click)="onDeleteSnapshot(snap)"
                      title="Delete this snapshot">✕</button>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #snapshotsLoadingTpl>
        <div class="ai-snapshot-empty">Loading...</div>
      </ng-template>
    </div>

    <!-- Library modal -->
    <div class="ai-confirm-overlay ai-library-modal-overlay" *ngIf="showLibrary" (click)="$event.target === $event.currentTarget && closeLibraryModal()">
      <div class="ai-library-modal-box" (click)="$event.stopPropagation()">
        <div class="ai-library-modal-header">
          <ng-container *ngIf="libraryPreviewEntry; else libraryModalTitleTpl">
            <button class="ai-transfer-btn" (click)="closeLibraryPreview()">← Back</button>
            <span class="ai-library-modal-title">{{ libraryPreviewEntry.name }}</span>
          </ng-container>
          <ng-template #libraryModalTitleTpl>
            <span class="ai-library-modal-title">AI Library</span>
          </ng-template>
          <button class="ai-delete-btn ai-library-modal-close" (click)="closeLibraryModal()" title="Close">✕</button>
        </div>
        <div class="ai-library-modal-body">

    <!-- In-modal entry preview -->
    <div class="ai-library-entry-preview-panel" *ngIf="libraryPreviewEntry">
      <div class="ai-library-desc" *ngIf="libraryPreviewEntry.description">{{ libraryPreviewEntry.description }}</div>
      <div class="ai-snapshot-date" style="margin-bottom:0.6rem">{{ libraryPreviewEntry.rules.length }} rule{{ libraryPreviewEntry.rules.length !== 1 ? 's' : '' }}</div>
      <div class="ai-import-preview">
        <div class="ai-import-preview-row" *ngFor="let r of libraryPreviewEntry.rules; let i = index">
          <span class="ai-rule-index">{{ i + 1 }}.</span>
          <span class="ai-cond">{{ pendingConditionName(r.conditionTypeId) }}</span>
          <span class="ai-arrow">→</span>
          <span class="ai-act">{{ pendingActionName(r.actionTypeId) }}</span>
        </div>
      </div>
      <div class="ai-library-preview-actions">
        <button class="ai-add-btn" (click)="loadLibraryEntryIntoEditor()">Load into Editor</button>
        <button class="ai-transfer-btn" (click)="closeLibraryPreview()">Cancel</button>
      </div>
    </div>

    <div class="ai-library-panel" *ngIf="!libraryPreviewEntry">

      <!-- Toolbar row -->
      <div class="ai-library-toolbar">
        <ng-container *ngIf="!showNewFolder">
          <button class="ai-transfer-btn ai-library-folder-btn"
                  (click)="showNewFolder = true"
                  title="Create a new folder">+ New Folder</button>
        </ng-container>

        <!-- New folder form (from toolbar) -->
        <ng-container *ngIf="showNewFolder">
          <div class="ai-library-save-form">
            <input class="ai-import-input ai-snapshot-name-input"
                   [(ngModel)]="newFolderName" placeholder="Folder name..." maxlength="100" autocomplete="off"
                   (keyup.enter)="onSaveFolder()">
            <div class="ai-library-save-actions">
              <button class="ai-add-btn" [disabled]="savingFolder || !newFolderName.trim()" (click)="onSaveFolder()">
                {{ savingFolder ? '...' : 'Create' }}
              </button>
              <button class="ai-transfer-btn" (click)="showNewFolder = false; newFolderName = ''">Cancel</button>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Search bar -->
      <input class="ai-import-input ai-library-search-input"
             [(ngModel)]="librarySearch"
             placeholder="Search library…"
             autocomplete="off">

      <div class="crew-err ai-err" *ngIf="libraryError">{{ libraryError }}</div>

      <ng-container *ngIf="!libraryLoading; else libraryLoadingTpl">

        <div class="ai-snapshot-empty"
             *ngIf="libraryFolders.length === 0 && libraryUnfiled.length === 0 && libraryShared.length === 0">
          No library entries yet.
        </div>

        <!-- ── Two-column browse layout ──────────────────────────────────── -->
        <div class="ai-library-browser"
             *ngIf="libraryFolders.length > 0 || libraryUnfiled.length > 0 || filteredLibraryShared.length > 0">

          <!-- Left nav column -->
          <div class="ai-library-nav">

            <!-- Your Library section -->
            <ng-container *ngIf="libraryFolders.length > 0 || libraryUnfiled.length > 0">
              <button class="ai-library-nav-section"
                      (click)="yourLibrarySectionExpanded = !yourLibrarySectionExpanded">
                <span class="ai-library-nav-chevron">{{ yourLibrarySectionExpanded ? '▾' : '▸' }}</span>
                <span>Your Library</span>
              </button>

              <ng-container *ngIf="yourLibrarySectionExpanded">
                <!-- Folder nav items -->
                <button class="ai-library-nav-item"
                        *ngFor="let folder of filteredLibraryFolders"
                        [class.ai-library-nav-active]="selectedLibraryView?.type === 'folder' && selectedLibraryView?.folderId === folder.folderId"
                        (click)="selectLibraryView('folder', folder.folderId)">
                  <span class="ai-library-nav-icon">📁</span>
                  <span class="ai-library-nav-label">{{ folder.name }}</span>
                  <span class="ai-library-nav-count">{{ folder.entries.length }}</span>
                </button>
                <!-- Unfiled nav item -->
                <button class="ai-library-nav-item"
                        *ngIf="filteredLibraryUnfiled.length > 0"
                        [class.ai-library-nav-active]="selectedLibraryView?.type === 'unfiled'"
                        (click)="selectLibraryView('unfiled')">
                  <span class="ai-library-nav-icon">📄</span>
                  <span class="ai-library-nav-label">Unfiled</span>
                  <span class="ai-library-nav-count">{{ filteredLibraryUnfiled.length }}</span>
                </button>
              </ng-container>
            </ng-container>

            <!-- Shared with you section -->
            <ng-container *ngIf="filteredLibraryShared.length > 0">
              <button class="ai-library-nav-section"
                      (click)="sharedSectionExpanded = !sharedSectionExpanded">
                <span class="ai-library-nav-chevron">{{ sharedSectionExpanded ? '▾' : '▸' }}</span>
                <span>Shared With You</span>
              </button>

              <ng-container *ngIf="sharedSectionExpanded">
                <button class="ai-library-nav-item"
                        [class.ai-library-nav-active]="selectedLibraryView?.type === 'shared'"
                        (click)="selectLibraryView('shared')">
                  <span class="ai-library-nav-icon">🔗</span>
                  <span class="ai-library-nav-label">All shared</span>
                  <span class="ai-library-nav-count">{{ filteredLibraryShared.length }}</span>
                </button>
              </ng-container>
            </ng-container>

          </div><!-- /.ai-library-nav -->

          <!-- Right preview column -->
          <div class="ai-library-preview">
            <div class="ai-snapshot-empty" *ngIf="!selectedLibraryView">
              Select a folder or section on the left to browse entries.
            </div>

            <!-- Folder view -->
            <ng-container *ngIf="selectedLibraryView?.type === 'folder'">
              <ng-container *ngFor="let folder of libraryFolders">
                <ng-container *ngIf="folder.folderId === selectedLibraryView?.folderId">

                  <!-- Folder header actions -->
                  <div class="ai-library-preview-header">
                    <span class="ai-library-preview-title">📁 {{ folder.name }}</span>
                    <div class="ai-snapshot-actions">
                      <button class="ai-transfer-btn ai-library-share-toggle"
                              (click)="toggleFolderSharePanel(folder.folderId)">
                        {{ sharingFolderId === folder.folderId ? 'Done' : 'Share' }}
                      </button>
                      <button class="ai-delete-btn" (click)="onDeleteFolder(folder)" title="Delete folder">✕</button>
                    </div>
                  </div>

                  <!-- Folder share list -->
                  <div class="ai-library-shares" *ngIf="folder.shares.length > 0">
                    <div class="ai-library-share-row" *ngFor="let share of folder.shares">
                      <span class="ai-library-share-label">
                        <span class="ai-library-share-type-badge"
                              [class.ai-badge-fleet]="share.shareType === 'fleet'"
                              [class.ai-badge-player]="share.shareType === 'player'">
                          {{ share.shareType === 'fleet' ? 'Fleet' : 'Player' }}
                        </span>
                        {{ shareLabel(share) }}
                      </span>
                      <button class="ai-delete-btn" (click)="onRemoveFolderShare(folder, share)">✕</button>
                    </div>
                  </div>

                  <!-- Folder share add panel -->
                  <ng-container *ngIf="sharingFolderId === folder.folderId">
                    <ng-container *ngTemplateOutlet="shareFormTpl; context: { entry: null, folder: folder, isFolder: true }"></ng-container>
                  </ng-container>

                  <!-- Folder entries -->
                  <div class="ai-snapshot-empty" *ngIf="filteredFolderEntries(folder).length === 0">No entries in this folder.</div>
                  <ng-container *ngFor="let entry of filteredFolderEntries(folder)">
                    <ng-container *ngTemplateOutlet="entryRowTpl; context: { $implicit: entry, inFolder: true }"></ng-container>
                  </ng-container>

                </ng-container>
              </ng-container>
            </ng-container>

            <!-- Unfiled view -->
            <ng-container *ngIf="selectedLibraryView?.type === 'unfiled'">
              <div class="ai-library-preview-header">
                <span class="ai-library-preview-title">📄 Unfiled</span>
              </div>
              <div class="ai-snapshot-empty" *ngIf="filteredLibraryUnfiled.length === 0">No unfiled entries.</div>
              <ng-container *ngFor="let entry of filteredLibraryUnfiled">
                <ng-container *ngTemplateOutlet="entryRowTpl; context: { $implicit: entry, inFolder: false }"></ng-container>
              </ng-container>
            </ng-container>

            <!-- Shared view -->
            <ng-container *ngIf="selectedLibraryView?.type === 'shared'">
              <div class="ai-library-preview-header">
                <span class="ai-library-preview-title">🔗 Shared With You</span>
              </div>
              <div class="ai-snapshot-list">
                <div class="ai-snapshot-row" *ngFor="let entry of filteredLibraryShared">
                  <div class="ai-snapshot-info">
                    <span class="ai-snapshot-name">{{ entry.name }}</span>
                    <span class="ai-snapshot-date">
                      by {{ entry.ownerName || entry.ownerUserId }}
                      <ng-container *ngIf="entry.sharedViaFolder"> · via 📁 {{ entry.folderName }}</ng-container>
                      · {{ entry.rules.length }} rule{{ entry.rules.length !== 1 ? 's' : '' }}
                    </span>
                    <span class="ai-library-desc" *ngIf="entry.description">{{ entry.description }}</span>
                  </div>
                  <div class="ai-snapshot-actions">
                    <button class="ai-transfer-btn ai-snapshot-load-btn" [disabled]="saving" (click)="openLibraryPreview(entry)">Preview</button>
                  </div>
                </div>
              </div>
            </ng-container>

          </div><!-- /.ai-library-preview -->
        </div><!-- /.ai-library-browser -->

      </ng-container>
      <ng-template #libraryLoadingTpl>
        <div class="ai-snapshot-empty">Loading...</div>
      </ng-template>
    </div><!-- /.ai-library-panel -->
        </div><!-- /.ai-library-modal-body -->
      </div><!-- /.ai-library-modal-box -->
    </div><!-- /.ai-library-modal-overlay -->

    <!-- ── Inline new-folder modal ───────────────────────────────────────────── -->
    <div class="ai-confirm-overlay" *ngIf="showInlineFolderModal" (click)="showInlineFolderModal = false">
      <div class="ai-confirm-box" (click)="$event.stopPropagation()">
        <div class="ai-confirm-title">New folder</div>
        <input class="ai-import-input" style="margin:0.5rem 0"
               [(ngModel)]="inlineFolderName" placeholder="Folder name..." maxlength="100" autocomplete="off"
               (keyup.enter)="onSaveInlineFolder()">
        <div class="crew-err ai-err" *ngIf="inlineFolderError">{{ inlineFolderError }}</div>
        <div class="ai-confirm-actions">
          <button class="btn btn-ghost" (click)="showInlineFolderModal = false; inlineFolderName = ''">Cancel</button>
          <button class="btn btn-primary" [disabled]="savingInlineFolder || !inlineFolderName.trim()" (click)="onSaveInlineFolder()">
            {{ savingInlineFolder ? '...' : 'Create' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ── Reusable entry row ────────────────────────────────────────────────── -->
    <ng-template #entryRowTpl let-entry let-inFolder="inFolder">
      <div class="ai-library-entry">
        <div class="ai-snapshot-row">
          <div class="ai-snapshot-info">
            <span class="ai-snapshot-name">{{ entry.name }}</span>
            <span class="ai-snapshot-date">{{ entry.createdAt | date:'MMM d, y' }} · {{ entry.rules.length }} rule{{ entry.rules.length !== 1 ? 's' : '' }}</span>
            <span class="ai-library-desc" *ngIf="entry.description">{{ entry.description }}</span>
          </div>
          <div class="ai-snapshot-actions">
            <button class="ai-transfer-btn ai-snapshot-load-btn" [disabled]="saving" (click)="openLibraryPreview(entry)">Preview</button>
            <button class="ai-transfer-btn ai-library-move-btn" (click)="toggleMoveEntry(entry.libraryId)">
              {{ movingEntryId === entry.libraryId ? 'Cancel' : 'Move' }}
            </button>
            <button *ngIf="!inFolder" class="ai-transfer-btn ai-library-share-toggle" (click)="toggleSharePanel(entry.libraryId)">
              {{ sharingLibraryId === entry.libraryId ? 'Done' : 'Share' }}
            </button>
            <button class="ai-delete-btn" (click)="onDeleteLibraryEntry(entry)">✕</button>
          </div>
        </div>

        <!-- Move picker -->
        <div class="ai-library-move-picker" *ngIf="movingEntryId === entry.libraryId">
          <span class="ai-library-move-label">Move to:</span>
          <button class="ai-library-move-opt" [class.ai-move-opt-current]="!entry.folderId" (click)="onMoveEntry(entry, null)">Unfiled</button>
          <button class="ai-library-move-opt" *ngFor="let f of libraryFolders"
                  [class.ai-move-opt-current]="entry.folderId === f.folderId"
                  (click)="onMoveEntry(entry, f.folderId)">📁 {{ f.name }}</button>
        </div>

        <!-- Entry shares (unfiled only) -->
        <div class="ai-library-shares" *ngIf="!inFolder && entry.shares.length > 0">
          <div class="ai-library-share-row" *ngFor="let share of entry.shares">
            <span class="ai-library-share-label">
              <span class="ai-library-share-type-badge"
                    [class.ai-badge-fleet]="share.shareType === 'fleet'"
                    [class.ai-badge-player]="share.shareType === 'player'">
                {{ share.shareType === 'fleet' ? 'Fleet' : 'Player' }}
              </span>
              {{ shareLabel(share) }}
            </span>
            <button class="ai-delete-btn" (click)="onRemoveEntryShare(entry, share)">✕</button>
          </div>
        </div>

        <!-- Entry share add panel (unfiled only) -->
        <ng-container *ngIf="!inFolder && sharingLibraryId === entry.libraryId">
          <ng-container *ngTemplateOutlet="shareFormTpl; context: { entry: entry, folder: null, isFolder: false }"></ng-container>
        </ng-container>
      </div>
    </ng-template>

    <!-- ── Share add form (entry or folder) ─────────────────────────────────── -->
    <!-- isFolder=true → uses folder share state; false → uses entry share state -->
    <ng-template #shareFormTpl let-entry="entry" let-folder="folder" let-isFolder="isFolder">
      <div class="ai-library-share-panel">
        <!-- Fleet / Player toggle -->
        <div class="ai-library-share-type-row">
          <label class="ai-library-share-type-label">
            <input type="radio" [name]="isFolder ? 'folderShareType_' + folder?.folderId : 'shareType_' + entry?.libraryId"
                   value="fleet"
                   [(ngModel)]="isFolder ? folderShareType : shareType"> Share with fleet
          </label>
          <label class="ai-library-share-type-label">
            <input type="radio" [name]="isFolder ? 'folderShareType_' + folder?.folderId : 'shareType_' + entry?.libraryId"
                   value="player"
                   [(ngModel)]="isFolder ? folderShareType : shareType"> Share with player
          </label>
        </div>

        <!-- Fleet note -->
        <div class="ai-library-share-fleet-note" *ngIf="(isFolder ? folderShareType : shareType) === 'fleet'">
          <span *ngIf="allianceId">All fleet members will be able to load this {{ isFolder ? 'folder' : 'entry' }}.</span>
          <span *ngIf="!allianceId" class="ai-library-share-warn">No fleet ID available — open the fleet tab first.</span>
        </div>

        <!-- PSS player search -->
        <ng-container *ngIf="(isFolder ? folderShareType : shareType) === 'player'">
          <!-- Selected player chip -->
          <div class="ai-library-player-selected" *ngIf="isFolder ? folderSharePlayerSelected : sharePlayerSelected">
            <span class="ai-library-player-name">
              {{ isFolder ? folderSharePlayerSelected?.userName : sharePlayerSelected?.userName }}
            </span>
            <button class="ai-delete-btn" (click)="isFolder ? (folderSharePlayerSelected = null) : (sharePlayerSelected = null)"
                    title="Clear selection">✕</button>
          </div>
          <!-- Search row (hidden once a player is selected) -->
          <ng-container *ngIf="!(isFolder ? folderSharePlayerSelected : sharePlayerSelected)">
            <div class="ai-library-player-search-row">
              <input class="ai-import-input ai-library-player-search-input"
                     [ngModel]="isFolder ? folderSharePlayerQuery : sharePlayerQuery"
                     (ngModelChange)="isFolder ? (folderSharePlayerQuery = $event) : (sharePlayerQuery = $event)"
                     placeholder="Search player name or ID…"
                     autocomplete="off"
                     (keyup.enter)="isFolder ? onSearchFolderSharePlayer() : onSearchSharePlayer()">
              <button class="ai-add-btn ai-library-player-search-btn"
                      [disabled]="isFolder ? (folderSharePlayerSearching || !folderSharePlayerQuery.trim()) : (sharePlayerSearching || !sharePlayerQuery.trim())"
                      (click)="isFolder ? onSearchFolderSharePlayer() : onSearchSharePlayer()">
                {{ (isFolder ? folderSharePlayerSearching : sharePlayerSearching) ? '…' : 'Search' }}
              </button>
            </div>
            <!-- Results list -->
            <div class="ai-library-player-results" *ngIf="(isFolder ? folderSharePlayerResults : sharePlayerResults).length > 0">
              <div class="ai-library-player-result"
                   *ngFor="let u of (isFolder ? folderSharePlayerResults : sharePlayerResults)"
                   (click)="isFolder ? selectFolderSharePlayer(u) : selectSharePlayer(u)">
                <span class="ai-library-player-result-name">{{ u.userName }}</span>
                <span class="ai-library-player-result-id">{{ u.userId }}</span>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <div class="crew-err ai-err" *ngIf="isFolder ? folderShareError : shareError">
          {{ isFolder ? folderShareError : shareError }}
        </div>

        <button class="ai-add-btn"
                [disabled]="(isFolder ? folderSharingInProgress : sharingInProgress)
                           || ((isFolder ? folderShareType : shareType) === 'fleet' && !allianceId)
                           || ((isFolder ? folderShareType : shareType) === 'player' && !(isFolder ? folderSharePlayerSelected : sharePlayerSelected))"
                (click)="isFolder ? onAddFolderShare(folder) : onAddShare(entry)">
          {{ (isFolder ? folderSharingInProgress : sharingInProgress) ? '...' : 'Add share' }}
        </button>
      </div>
    </ng-template>

  </div>

  <!-- Rule list -->
  <div class="ai-list-wrap">
    <div class="ai-rule-list" *ngIf="internalRules.length > 0; else noRules"
         (dragover)="onListDragOver($event)"
         (drop)="onListDrop($event)">

      <!-- Drop indicator at position 0 (before first row) -->
      <div class="ai-drop-indicator"
           *ngIf="dragSourceIndex !== null && dropIndicatorIndex === 0 && dragSourceIndex !== 0"></div>

      <ng-container *ngFor="let rule of sortedRules; let i = index; trackBy: trackByRule">
        <div class="ai-rule"
             [class.ai-rule-dragging]="dragSourceIndex === i"
             [class.ai-rule-editing]="editingIndex === i"
             draggable="true"
             (click)="onRuleContainerClick(rule, i, $event)"
             (dragstart)="onDragStart($event, i)"
             (dragover)="onDragOver($event, i)"
             (drop)="onDrop($event)"
             (dragend)="onDragEnd()">

          <!-- Display mode -->
          <ng-container *ngIf="editingIndex !== i">
            <input *ngIf="lineSelectionMode" type="checkbox" class="ai-select-check" 
                   [checked]="isRuleSelected(rule)" 
                   (change)="onToggleRuleSelection(rule, $event)" 
                   (click)="$event.stopPropagation()">
            <span class="ai-drag-handle" title="Drag to reorder">⠿</span>
            <span class="ai-rule-index">{{ rule.index + 1 }}.</span>
            <span class="ai-cond ai-rule-click" title="Click to edit">{{ conditionName(rule.conditionTypeId) }}</span>
            <span class="ai-arrow">→</span>
            <span class="ai-act ai-rule-click" title="Click to edit">{{ actionLabel(rule.actionTypeId) }}</span>
            <button class="ai-delete-btn" [disabled]="saving" (click)="onDeleteRule(rule, $event)" title="Delete rule">✕</button>
          </ng-container>

          <!-- Edit mode -->
          <ng-container *ngIf="editingIndex === i">
            <span class="ai-drag-handle" style="visibility:hidden">⠿</span>
            <span class="ai-rule-index">{{ rule.index + 1 }}.</span>
            <div class="ai-combo">
              <input class="ai-combo-input" [(ngModel)]="editConditionSearch"
                     (focus)="openEditConditionCombo()" (input)="onEditConditionInput()"
                     (blur)="closeEditCombo('cond')" autocomplete="off">
              <div class="ai-combo-drop" *ngIf="editConditionOpen">
                <div class="ai-combo-opt" *ngFor="let opt of filteredEditConditionTypes()"
                     (mousedown)="selectEditCondition(opt)">{{ opt.name }}</div>
                <div class="ai-combo-empty" *ngIf="filteredEditConditionTypes().length === 0">No match</div>
              </div>
            </div>
            <span class="ai-arrow">→</span>
            <div class="ai-combo">
              <input class="ai-combo-input" [(ngModel)]="editActionSearch"
                     (focus)="openEditActionCombo()" (input)="onEditActionInput()"
                     (blur)="closeEditCombo('act')" autocomplete="off">
              <div class="ai-combo-drop" *ngIf="editActionOpen">
                <div class="ai-combo-opt" *ngFor="let opt of filteredEditActionTypes()"
                     (mousedown)="selectEditAction(opt)">{{ actionOptionLabel(opt.id) }}</div>
                <div class="ai-combo-empty" *ngIf="filteredEditActionTypes().length === 0">No match</div>
              </div>
            </div>
            <button class="ai-save-edit-btn"
                    [disabled]="!editConditionId || !editActionId || saving"
                    (click)="onSaveEdit($event)" title="Save changes">✓</button>
            <button class="ai-cancel-edit-btn" (click)="onCancelEdit($event)" title="Cancel">✕</button>
          </ng-container>
        </div>

        <!-- Drop indicator after this row -->
        <div class="ai-drop-indicator"
             *ngIf="dragSourceIndex !== null && dropIndicatorIndex === i + 1 && dragSourceIndex !== i && dragSourceIndex !== i + 1"></div>
      </ng-container>
    </div>
    <div class="ai-list-saving" *ngIf="saving && internalRules.length > 0">
      <span class="ai-saving-spinner"></span>
    </div>
  </div>

  <ng-template #noRules>
    <div class="ai-empty">{{ emptyMessage }}</div>
  </ng-template>

  <!-- Add row -->
  <div class="ai-add-row">
    <div class="ai-combo">
      <input class="ai-combo-input" [(ngModel)]="conditionSearch"
             (focus)="openConditionCombo()" (input)="onConditionInput()"
             (blur)="closeCombo('cond')" placeholder="condition" autocomplete="off">
      <div class="ai-combo-drop" *ngIf="conditionOpen">
        <div class="ai-combo-opt" *ngFor="let c of filteredConditionTypes()"
             (mousedown)="selectCondition(c)">{{ c.name }}</div>
        <div class="ai-combo-empty" *ngIf="filteredConditionTypes().length === 0">No match</div>
      </div>
    </div>

    <span class="ai-arrow">→</span>

    <div class="ai-combo">
      <input class="ai-combo-input" [(ngModel)]="actionSearch"
             (focus)="openActionCombo()" (input)="onActionInput()"
             (blur)="closeCombo('act')" placeholder="action" autocomplete="off">
      <div class="ai-combo-drop" *ngIf="actionOpen">
        <div class="ai-combo-opt" *ngFor="let a of filteredActionTypes()"
             (mousedown)="selectAction(a)">{{ actionOptionLabel(a.id) }}</div>
        <div class="ai-combo-empty" *ngIf="filteredActionTypes().length === 0">No match</div>
      </div>
    </div>

    <button class="ai-add-btn" [disabled]="saving || !selectedConditionId || !selectedActionId" (click)="onAddRule()">
      {{ saving ? '...' : '+ Add' }}
    </button>
  </div>

  <div class="crew-err ai-err" *ngIf="error || importError || snapshotError">{{ error || importError || snapshotError }}</div>

</div><!-- /.ai-pane-wrap -->
